import { ModuleWithProviders, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [

  {
    path: '',
    loadChildren: () => import('./forgotpassword/forgotpassword.module').then(m => m.ForgotpasswordModule)
  },
  // {
  //   path: 'error',
  //   loadChildren: () => import('./forgotpassword/forgotpassword.module').then(m => m.ForgotpasswordModule)
  // },
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:true})],
  exports: [RouterModule]
})

export class AppRoutingModule { }
// export const AppRoutingModule: ModuleWithProviders<any> = RouterModule.forRoot(routes ,{useHash: true})
